














import { Vue, Component, Prop } from "vue-property-decorator";
import i18n from "@/i18n";

@Component
export default class MonthFilter extends Vue {
  // Props

  @Prop({ required: true })
  public value!: string;

  @Prop({ default: i18n.t("_placeholder.click_to_select_month") })
  public placeholder!: string;

  @Prop({ default: false })
  public disabled!: boolean;

  // Data

  public timeStampPicked: string | Date = "";

  // Life-cycle methods

  public created() {
    this.timeStampPicked = this.value ? new Date(this.value) : new Date();
  }

  // Methods

  public onInput = this.$_.debounce($event => {
    this.$emit("input", this.$moment.utc($event).local());
  }, 250);
}
